module.exports = __webpack_public_path__ + "img/peisong.73f4ff6d.png";